import axios from "axios";
import { authHeader } from "../../utils/helperFunction";



const EmployerApi =  {
    getPlacementsDetails : () => {
        return axios({
            method:'get',
            url:'https://placementportalwebservices.herokuapp.com/api/employer/getInterns',
            headers : authHeader()
        }).then(res => res.data).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
           
            return Promise.reject(e)
        })
    },
    updateAttendanceRecord: (body:any) => {
        return axios.post("https://placementportalwebservices.herokuapp.com/api/employer/updateAttendance",body,{headers : authHeader()}).then(res => {
            return res
        }).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    },

}
export default EmployerApi;